import React from 'react';
import cn from 'classnames';
import { makeAnchor } from '../../utils/navigation';

import styles from './MobileNavigation.css';

export default class MobileNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMobile: false
        };
    }

    toggleMobileMenu = () => {
        const { showMobile } = this.state;
        this.setState({ showMobile: !showMobile });
    };

    render() {
        const { options, activeTab, onClick } = this.props;
        return (
            <nav>
                <ul
                    className={cn('mobile', {
                        open: this.state.showMobile
                    })}
                >
                    {options.map(({ title, className }, i) => (
                        <li
                            key={`nav-link-${title}`}
                            id={`${makeAnchor(title)}-link-mobile`}
                            data-metrics-type="TAB"
                            className={cn(
                                'mobile-nav-item',
                                {
                                    active: activeTab === i
                                },
                                className
                            )}
                        >
                            <a
                                onClick={(e) => {
                                    this.toggleMobileMenu();
                                    return onClick(e, i);
                                }}
                                href={`#${makeAnchor(title)}`}
                            >
                                {title}
                            </a>
                        </li>
                    ))}
                </ul>
                <style jsx>{styles}</style>
            </nav>
        );
    }
}
